import FormCreateViewModel from './view-model/FormCreateViewModel';
import { FormSource, FormSourceType } from './view-model/FormSource';

export function isConditionForm<T extends FormSource | FormCreateViewModel>(
  src: T
): src is Extract<T, { type: FormSourceType.CONDITION }> {
  return src.type === FormSourceType.CONDITION;
}

export function isPredefinedForm<T extends FormSource | FormCreateViewModel>(
  src: T
): src is Extract<T, { type: FormSourceType.PREDEFINED }> {
  return src.type === FormSourceType.PREDEFINED;
}
